import React from 'react';
import { Container } from '@mui/material';
import FlashcardsManager from './components/FlashcardsManager';

export default function FlashcardsPage(){
  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <FlashcardsManager />
    </Container>
  );
}
